import { ReactNode } from 'react';
import { useMobileViewport } from '@/hooks/use-mobile-viewport';
import { Outlet } from 'react-router-dom';
import { ExpandableChat } from '@/features/ai/components/expandable-chat';
import { AssistantModeBanner } from '@/features/assistant-access/components/assistant-mode-banner';
import { AnnouncementBar } from '@/features/events/components/announcement-bar/announcement-bar';
import { PlanRestorePrompt } from '@/features/settings/components/plan-restore-prompt';
import { Header } from './header';
import { MobileTabBar } from './mobile-tab-bar';
import { Sidebar } from './sidebar';
import './main-layout.css';

interface MainLayoutProps {
  children?: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  // The tab bar builds the role-based menu a second time; on a wider screen it would do that
  // work for nothing.
  const isPhone = useMobileViewport();

  return (
    <div className="main-layout">
      <AnnouncementBar />
      <AssistantModeBanner />
      <Header />

      <div className="main-layout__body">
        <Sidebar />

        <div className="main-layout__content">
          <main className="main-layout__main">
            <div className="main-layout__main-inner">
              {children || <Outlet />}
            </div>
          </main>
        </div>
      </div>

      {isPhone && <MobileTabBar />}

      <ExpandableChat />
      <PlanRestorePrompt />
    </div>
  );
}
